import { APP_ENV } from 'src/env'

export const getFirstCharacterUpperCase = (str) => {
    if (str)
        return str
            .toLowerCase()
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
    else return null
}

export const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
}

export const validatePhoneNumber = (phoneNumber) => {
    return String(phoneNumber)
        .toLowerCase()
        .match(
            // eslint-disable-next-line no-useless-escape
            /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
        )
}

export const blobToFile = (theBlob, fileName) => {
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    theBlob.lastModifiedDate = new Date()
    theBlob.name = fileName
    return theBlob
}

export const disallowSpecialCharRegex = (str) => {
    let regex = /[^A-z\s\d]/g
    return !regex.test(str)
}

export const disallowSpecialCharRegexWithoutRoundBracket = (str) => {
    // eslint-disable-next-line no-useless-escape
    let regex = /[^A-z\s\d\(\)]/g
    return !regex.test(str)
}

export const disallowSpecialCharRegexWithoutDot = (str) => {
    // eslint-disable-next-line no-useless-escape
    let regex = /[^A-z\s\d\.]/g
    return !regex.test(str)
}

export const disallowSpecialCharRegexWithoutDotSlashPeriodParens = (str) => {
    // eslint-disable-next-line no-useless-escape
    let regex = /[^A-z\s\d.\/\\()\-']/g
    return !regex.test(str)
}
export const disallowSpecialCharRegexWithoutDotPeriodParens = (str) => {
    // eslint-disable-next-line no-useless-escape
    let regex = /[^A-z\s\d.\()\-']/g
    return !regex.test(str)
}
export const disallowSpecialCharRegexAndNumbers = (str) => {
    // eslint-disable-next-line no-useless-escape
    let regex = /[^A-z\s\.]/g
    return !regex.test(str)
}

export const convertCamelcaseToSnakecase = (str) =>
    str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)

export const convertSnakecaseToRegularString = (str) => str.split('_').join(' ')

export const convertSnakecaseToRegularStringWithUppercase = (str) =>
    str
        .split('_')
        .map((i) => getFirstCharacterUpperCase(i))
        .join(' ')

export const convertRegularStringToCamelCase = (text) => {
    // Case-changing characters:
    //  hyphen -
    //  underscore _
    //  period .
    //  space
    const a = text
        .toLowerCase()
        .replace(/[-_\s.]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ''))
    return a.substring(0, 1).toLowerCase() + a.substring(1)
}

export const stringIsOnlyWhitespace = (string) => {
    if (!string) return true
    return /^\s*$/.test(string)
}

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1)
}

// validate the given ip
export const isValidIP = (IP) => {
    // Regex expression for validating IPv4
    let ipv4 =
        /(([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])/

    // Regex expression for validating IPv6
    // eslint-disable-next-line no-useless-escape
    let ipv6 = /((([0-9a-fA-F]){1,4})\:){7}([0-9a-fA-F]){1,4}/

    // Checking if it is a valid IPv4 addresses
    if (IP.match(ipv4)) return true
    // Checking if it is a valid IPv6 addresses
    else if (IP.match(ipv6)) return true

    // Return Invalid
    return false
}

export const sleep = async (delay) => {
    return new Promise((res) => setTimeout(res, delay))
}

export const timestampDisplayFormat = 'MMM D, YYYY [at] hh:mm A'

export const isProduction = APP_ENV.REACT_APP_IS_PROD === 'true'

// CYPRESS user config
export const IS_CYPRESS = APP_ENV.REACT_APP_STAGE === 'cypress'
export const CYPRESS_OPTIONS = {
    userOrganizationId: APP_ENV.REACT_APP_CYPRESS_USER_ORG,
    headers: {
        'x-cypress-testing': APP_ENV.REACT_APP_CYPRESS_KEY,
        'x-cypress-email': APP_ENV.REACT_APP_CYPRESS_USER_EMAIL,
        'x-cypress-org': APP_ENV.REACT_APP_CYPRESS_USER_ORG,
    },
}

/**
 * Whether two sets are equal
 * @param {Set<any>} set1
 * @param {Set<any>} set2
 * @returns {boolean}
 */
export function areSetsEqual(set1, set2) {
    return set1.size === set2.size && [...set1].every((item) => set2.has(item))
}
